// ============================================================================
// TYPES FOR PURCHASE ORDER FORM
// ============================================================================

// Base Types
export type AccountingType = 'A' | 'B';
export type Currency = 'ARS' | 'USD';
export type CostCenterStrategy = 'GLOBAL' | 'PER_LINE' | 'UNASSIGNED';
export type CostCenterType = 'PROJECT' | 'GENERAL';

// ============================================================================
// HEADER
// ============================================================================

export interface PurchaseOrderHeader {
  supplierId: number;
  orderDate: string; // ISO format
  accountingType: AccountingType;
  ivaCode: string | null; // "21", "10.5", "27" or null if type B
  currency: Currency;
}

// ============================================================================
// COST CENTER CONFIGURATION
// ============================================================================

export interface GlobalCostCenter {
  costCenterType: CostCenterType;
  projectId: number | null; // only if PROJECT
  generalCostCenterId: number | null; // always null for GENERAL (not used anymore)
  workCategoryId: number; // associated work category (for PROJECT) or general work category (for GENERAL)
}

export interface PurchaseOrderCostCenterConfig {
  costCenterStrategy: CostCenterStrategy;
  globalCostCenter: GlobalCostCenter | null;
}

// ============================================================================
// ITEMS
// ============================================================================

export interface PurchaseOrderItemAllocation {
  costCenterType: CostCenterType;
  projectId: number | null; // only if PROJECT
  generalCostCenterId: number | null; // always null for GENERAL (not used anymore)
  workCategoryId: number; // work category (for PROJECT) or general work category (for GENERAL)
  allocatedQuantity: number; // > 0
}

export interface PurchaseOrderItem {
  id: string; // temporary frontend id
  description: string;
  unit: string; // "M2", "M", "UN", "KG", "L", etc.
  unitPrice: number;
  quantity?: number; // only for GLOBAL strategy
  allocations: PurchaseOrderItemAllocation[]; // empty only if GLOBAL
}

// ============================================================================
// COMPLETE PURCHASE ORDER
// ============================================================================

export interface PurchaseOrderRequest {
  supplierId: number;
  orderDate: string;
  accountingType: AccountingType;
  ivaCode: string | null;
  currency: Currency;
  costCenterStrategy: CostCenterStrategy;
  globalCostCenter: GlobalCostCenter | null;
  items: PurchaseOrderItem[];
}

// ============================================================================
// MOCK DATA INTERFACES
// ============================================================================

export interface MockSupplier {
  id: number;
  name: string;
  cuit: string;
}

export interface MockWorkCategory {
  id: number;
  name: string;
  isSystemDefault?: boolean;
}

export interface MockProject {
  id: number;
  name: string;
  workCategories: MockWorkCategory[];
}

export const ivaOptions = [
  { value: '21', label: '21%' },
  { value: '10.5', label: '10.5%' },
  { value: '27', label: '27%' },
];

export const mockUnits = [
  'UN',
  'M',
  'M2',
  'M3',
  'KG',
  'TON',
  'L',
  'BOLSA',
  'CAJA',
  'PAQUETE',
];


